
import React, { useState } from "react"
import _ from "lodash"
import {
    Row, Col, Button,
    FormGroup,
    InputGroup,
    Input,
    InputGroupAddon,
} from "reactstrap"
import { useTranslation } from 'react-i18next'

function InputWithBtn({ title, handleChange }) {

    let { t } = useTranslation()

    let [searchInput , setSearchInput] = useState()

    let submitSearch = (e) => {
        e.preventDefault();
        handleChange(searchInput)
    }
    
    return (
        <>
            <p className="text-muted">{title}</p>
            <Row >
                <Col md="12" className="mb-n3 mt-n4">
                    <FormGroup>
                        {/*<InputGroup className="align-items-center">*/}
                        <form onSubmit={submitSearch}>
                            <Input
                                placeholder={t('search')}
                                style={{ height: "50%" , marginTop: "1%",  marginBottom: "1%"}}
                                value={searchInput}
                                onChange={(e)=> setSearchInput(e.target.value)}
                            />
                            {/*<InputGroupAddon addonType="append"><Button color="info" onClick={()=> handleChange(searchInput)} >{t('search')}</Button></InputGroupAddon>*/}
                            </form>
                        {/*</InputGroup>*/}
                    </FormGroup>
                </Col>
            </Row>
        </>
    )
}

export default InputWithBtn